import { atom } from 'recoil';

import { TChannelType } from 'shared/domain/entities';

export const disabledChannels = atom<TChannelType[]>({
  key: 'disabledChannels',
  default: [],
});
